const url = '/passengersPhones';
const Provider = 'PassengerPhones';
const dbModel = 'PassengerPhones';

export { url, Provider, dbModel };
